import { colorsPalettes } from "@similarweb/styles";
import { StyledExportToast } from "./styles";
import { CircularLoader } from "app/components/React/CircularLoader/CircularLoader";
import type { ToastProps } from "app/pages/sales-intelligence/common-components/export-table/cells/types";

const ManagementToast = ({ text }: ToastProps) => {
    return (
        <StyledExportToast>
            <span>{text}</span>
            <CircularLoader options={{ svg: { stroke: colorsPalettes.midnight["50"] } }} />
        </StyledExportToast>
    );
};

export default ManagementToast;
